module.exports = __webpack_public_path__ + "static/media/text-file-line.013bffbe.svg";